

import React, { memo, useState, useMemo } from 'react';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import _memoize from 'lodash.memoize';
import { FormModal, Text, Input, Row, Col } from '../../../../ui-kit';

import './styles/_template-details.scss';

const TEMPLATE_DESCRIPTION_LIMIT = 160;












const ElevateDetails = (props) => {
  const {
    title,
    visible,
    onClose,
    action,
    templateId,
    updateTemplate,
    editDetails,
    setTemplateDetails
  } = props;
  const { templateName: elevateTemplateName, templateDescription: description } = editDetails;

  const [templateName, setTemplateName] = useState(elevateTemplateName);
  const [templateDescription, setTemplateDescription] = useState(description);

  const onSave = async () => {
    await updateTemplate({
      templateId,
      action,
      optionalParams: {
        templateName,
        templateDescription
      }
    });
    setTemplateDetails();
    onClose();
  };

  const updateInputField = _memoize((field) => (result) => {
    const inputValue = getStringValueFromGenericInput(result);
    if (field === 'templateName') {
      setTemplateName(inputValue);
    } else {
      setTemplateDescription(inputValue);
    }
  });

  const saveDisabled = useMemo(() => {
    if (!templateName || !templateDescription) {
      return true;
    }
    if (templateDescription && templateDescription.length > TEMPLATE_DESCRIPTION_LIMIT) {
      return true;
    }
    return false;
  }, [templateName, templateDescription]);


  return (
    <FormModal
      key="template-details-modal"
      title={title}
      subtitle="View and manage details of this template page"
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      saveDisabled={saveDisabled}
      stayOpenOnSave
      saveText="Save Changes">

      <div className="template-details-modal">
        <div className="template-details-modal__basic-info">
          <div className="template-details-modal__basic-info__edit">
            <Text heading5>Basic Info</Text>
            <div className="template-details-modal__basic-info__edit__section">
              <Row nogutter className="template-details-modal__basic-info__edit__section__inputs">
                <Col md={12}>
                  <Input
                    id="pagename-input"
                    placeholder="Template Name"
                    label="Template Name"
                    labelProps={{ required: true }}
                    defaultValue={templateName}
                    value={templateName}
                    onChange={updateInputField('templateName')} />

                </Col>
              </Row>
              <Row nogutter className="template-details-modal__basic-info__edit__section__inputs">
                <Col md={12}>
                  <Input
                    multiline
                    label="Description"
                    placeholder="Add a short description about this template and what it's used for"
                    defaultValue={templateDescription}
                    onChange={updateInputField('templateDescription')}
                    labelProps={{ required: true }}
                    rows={3} />

                  {
                  templateDescription &&
                  templateDescription.length > TEMPLATE_DESCRIPTION_LIMIT &&
                  <Text danger label>
                        Max 160 characters. Please shorten your description.
                      </Text>}


                </Col>
              </Row>
            </div>
          </div>
          <Text caption block className="template-details-modal__basic-info__details">
            Template ID:
            {' '}
            {templateId}
          </Text>
        </div>
      </div>
    </FormModal>);

};

export default memo(ElevateDetails);